module.exports = "/fonts/fa-brands-400.ttf?21964f74b00a1599fae9d0a993e9eaba";